<script setup lang="ts">
import { useAuthStore } from "~/store/auth/auth.store";
import { useSessionsStore } from "~/store/sessions/sessions-store";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useFormats } from "~/composables/utils/useFormat";
import { useSessionDetailsAttendeesStore } from "~/store/sessions/session-details-attendees-store";

const sessionsStore = useSessionsStore();
const { trainingPlanSessionIndividual } = storeToRefs(sessionsStore);
const sessionDetailsAttendeesStore = useSessionDetailsAttendeesStore();
const { updateUnscheduleAttendeeModal } = storeToRefs(sessionDetailsAttendeesStore);
const authStore = useAuthStore();
const format = useFormats();
</script>

<template>
  <div class="session_user_info__container">
    <div class="flex gap-1 items-center justify-between">
      <h3 class="heading_3_demi text-primary-color p-[8px]">Détails de la déplanification</h3>
      <SvgIcon
        v-if="authStore.isNotManager"
        name="edit"
        class="w-[16px] h-[16px] button_secondary_default cursor-pointer"
        @click="
          () => {
            updateUnscheduleAttendeeModal = true;
          }
        "
      ></SvgIcon>
    </div>
    <div class="session_user_info__grid">
      <section>
        <h5>Motif</h5>
        <p class="truncate">{{ trainingPlanSessionIndividual?.cancelReason ?? "-" }}</p>
      </section>
      <section>
        <h5>Date d’annonce</h5>
        <p class="truncate">
          {{
            trainingPlanSessionIndividual?.cancelDate
              ? format.toDateDisplay(trainingPlanSessionIndividual?.cancelDate)
              : "-"
          }}
        </p>
      </section>
      <section>
        <h5>Commentaire</h5>
        <p>
          {{
            trainingPlanSessionIndividual?.cancelComment && trainingPlanSessionIndividual?.cancelComment !== ""
              ? trainingPlanSessionIndividual?.cancelComment
              : "-"
          }}
        </p>
      </section>
      <section>
        <h5>Déplanifié par</h5>
        <p>{{ trainingPlanSessionIndividual?.canceledBy ?? "-" }}</p>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.session_user_info__container {
  @apply pt-[8px];
  border-bottom: 1px solid var(--grey-lightest);
}

.session_user_info__grid {
  @apply flex flex-col gap-[8px] px-[8px] mb-[32px] mt-[16px];

  section {
    @apply inline-flex px-[8px];

    h5 {
      @apply min-w-[112px] mr-[8px];
      color: var(--text-secondary-color);
    }
  }
}
</style>
